
import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import { Col, Row } from "antd";
import { CustomLabel } from "../../Common/style";
import OTPInput from "otp-input-react";
import FooterButton from "../../Pages/Footer";
import "./style.css";

export const ActionButton = styled.button`
  border: none;
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  color: #0284C9;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:not(:disabled):hover {
    color: ${({ hoverColor }) => hoverColor};
    cursor: pointer;
  }
`;

const OtpInputCard = ({ title, resendOTP,otpValue, setOtpValue, ...rest }) => {
  return (
    <div
      style={{
        padding: 12,
        textAlign: "left",
        minWidth: "365px"
      }}
    >
      <div style={{ marginBottom: "12px" }}>{title}</div>
      <OTPInput
        inputStyles={{
          border: "1px solid #cbcbcb",
          width: "50px",
          height: "50px",
        }}
        focusStyle={{
          border: "1px solid #cbcbcb",
        }}
        value={otpValue}
        onChange={setOtpValue}
        {...rest}
      />
    </div>
  );
};

function OtpCard({ validateOtp, resendOtp,  otpValue, setOtpValue, isLoadingType, btnAlign = "right" }) {
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(1);
  const [timeDone, setDone] = useState(false);
  const [isResendDisable, setIsResendDisable] = useState(true);

  useEffect(() => {
    if (timeDone) return; // If time is done, stop the timer
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(prevSeconds => prevSeconds - 1);
      } else if (minutes > 0) {
        setMinutes(prevMinutes => prevMinutes - 1);
        setSeconds(59); // Reset seconds to 59
      } else {
        clearInterval(interval); // Stop the interval once the time is done
        setDone(true);
        setIsResendDisable(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, minutes, timeDone]);

  const handleResend = async (e) => {
    const otpId = await resendOtp();
    if(otpId){
      setOtpValue("");
      setDone(false); // Reset the "time done" state
      setIsResendDisable(true);
      setMinutes(1); // Reset minutes to 1 (or whatever your initial value is)
      setSeconds(0); // Reset seconds to 59
    }
  };
  const getCountingFormat = (count) => {
    return count < 10 ? `0${count}` : count
  }
  return (
    <div>
      <OtpInputCard
        title={`Please Enter the OTP received on your registered mobile number.`}
        setOtpValue={setOtpValue}
        otpValue={otpValue}
        autoFocus
        OTPLength={4}
        otpType="number"
        disabled={false}
      />
      <Row
        style={{
          maxWidth: "360px",
          justifyContent: "space-between",
        }}
      >
        <Col xs={12}>
        {!timeDone && (
          <div style={{ display: "flex", padding: "5px 0px 0px 20px", alignItems: "center" }}>
                <CustomLabel font_size="14" font_weight="bold">
                {getCountingFormat(minutes)} : {getCountingFormat(seconds)}
                </CustomLabel>
          </div>
        )}
        </Col>
        <Col xs={12}>
        <ActionButton
          submitType="button"
          onClick={handleResend}
          disabled={isResendDisable}
          style={{ margin: "5px 0", padding: "0" }}
        >
          {"RESEND OTP"}
        </ActionButton>
        </Col>
      </Row>
      {(otpValue && otpValue?.length === 4) && <div style={{ display: "flex", justifyContent: "space-between" }}>
        <FooterButton
          onNext={() => validateOtp(isLoadingType)}
          nextLabel="Verify"
          hideBack={true}
          mobileNextPos={btnAlign}
        />
      </div>}
    </div>
  );
}

export default OtpCard;
